import { Id } from '../../types';
import * as ss from 'superstruct';
import { PaidSourceResource } from './paid-source.resource';

export const TrackedUrlResource = ss.type({
  id: Id,
  paidSource: PaidSourceResource,

  /** For matching. */
  urlPrefix: ss.string(),

  /** Optional URL for Proxy to redirect to.
   *
   * You can keep a tracked URL and clear this to remember historic routes
   * or for websites that don't use the proxy.
   */
  replacementPrefix: ss.optional(ss.nullable(ss.string())),
});

export type TrackedUrlResource = ss.Infer<typeof TrackedUrlResource>;
